import { getSmartPageUrlSuffix } from '@bingads-webui-campaign/smart-page-url-suffix-provider';

// TODO make this helper only depends on subDomain and siteSuffix not siteConfig
export const getSmartPageUrl = (siteConfig, domain) => {
  const subDomain = (siteConfig && siteConfig.subDomain) || '';
  const siteSuffix = (siteConfig && siteConfig.siteSuffix) || '';

  return `https://${subDomain}${getSmartPageUrlSuffix(domain)}/${siteSuffix}`;
};
